import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Declare gtag function for TypeScript
declare global {
  interface Window {
    gtag: (
      command: string,
      targetId: string,
      config?: Record<string, any>
    ) => void;
    dataLayer: any[];
  }
}

export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // Track page view when route changes
    if (window.gtag) {
      window.gtag("config", "G-G1SDC51HD5", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}

